// client/src/ImageModal.js
import React from 'react';

function ImageModal({ imageUrl, onClose }) {
  // Prevent clicks inside the image from closing the modal
  const handleImageClick = (e) => {
    e.stopPropagation();
  };

  return (
    // The backdrop, which closes the modal on click
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75 transition-opacity"
    >
      {/* A close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white text-3xl font-bold hover:text-gray-300"
        aria-label="Close image view"
      >
        ×
      </button>

      {/* The image container */}
      <div className="relative">
        <img
          src={imageUrl}
          alt="Zoomed view"
          onClick={handleImageClick}
          className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
        />
      </div>
    </div>
  );
}

export default ImageModal;